import { reactive } from 'vue'
import config from '@/config'
import storage from '@/utils/storage'

// 按公众号区分缓存，避免测试与正式环境复用身份。
const scope = 'parent_' + config.wx.appId
const KEYS = { openid: scope + '_openid', token: scope + '_token', user: scope + '_user' }
const BINDING_KEY = 'jxab:' + scope + '_binding_openid'

function readBindingOpenid() {
  try {
    return window.sessionStorage.getItem(BINDING_KEY) || ''
  } catch {
    return ''
  }
}

const token = storage.get(KEYS.token, '')
export const authState = reactive({
  // 无 token 时只读取本会话待绑定身份，不使用长期缓存的 openId 登录。
  openid: token ? storage.get(KEYS.openid, '') : readBindingOpenid(),
  token,
  userInfo: token ? storage.get(KEYS.user) : null,
  error: '',
})

// 两种登录共用同一结果保存入口。openId 用于绑定，token 用于业务请求。
export function setLoginResult(data) {
  if (!data?.openId) throw new Error('登录接口未返回微信身份，请换一个新的 code 重试')
  authState.openid = data.openId
  authState.token = data.token || ''
  authState.userInfo = data.user
  authState.error = ''
  storage.set(KEYS.openid, authState.openid)
  storage.set(KEYS.token, authState.token)
  storage.set(KEYS.user, authState.userInfo)
  if (authState.token) window.sessionStorage.removeItem(BINDING_KEY)
  else window.sessionStorage.setItem(BINDING_KEY, authState.openid)
}

export function clearAuth() {
  authState.openid = ''
  authState.token = ''
  authState.userInfo = null
  Object.values(KEYS).forEach((key) => storage.remove(key))
  try {
    window.sessionStorage.removeItem(BINDING_KEY)
  } catch {
    // 存储不可用时也已清理内存身份，401 仍能通知页面退出登录。
  }
}
